import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Country} from '../models/res/country';
import {PageableResponse} from '../models/datasource/pageable-response';
import {RequestMethod, RestService} from './rest.service';
import {Actions, ApiEndpoints} from '../constants/ApiEndpoints';
import {ResponseSnackbarService} from './response-snackbar.service';
import {State} from '../models/res/state';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private states: any[] = [];
  private counties: State[] = [];
  private countries: Country[] = [];

  constructor(private restService: RestService,
              private responseSnackBar: ResponseSnackbarService) {}

  getCountries(): Observable<Country[]> {
    return new Observable<Country[]>(obs => {
      if (this.countries && this.countries.length > 0) {
        obs.next(this.countries);
      } else {
        this.restService.publicRequest<PageableResponse<Country>>(RequestMethod.GET, '/p1/' + ApiEndpoints.RES.COUNTRY, Actions.BASE_ACTIONS.READALL).subscribe(response => {
          if (response.success) {
            this.countries = response.data.items;
            obs.next(this.countries);
            this.addOtherCountry(this.countries);
          } else {
            obs.next([]);
            this.responseSnackBar.onResponse(response);
          }
        });
      }
    });
  }

  /**
   * Add Other Country at the bottom of the list.
   */
  addOtherCountry(countries: Country[]) {
    const country = this.countries.find(x => x.name === 'Other');
    this.countries.splice(this.countries.length, 0, country);
    this.countries.splice(this.countries.indexOf(country), 1);
  }

  getStates(countryId: number): Observable<State[]> {
    return new Observable<State[]>(obs => {
      if (this.states && this.states[countryId] && this.states[countryId].length > 0) {
        obs.next(this.states[countryId]);
      } else {
        this.restService.request<PageableResponse<State>>(RequestMethod.GET, ApiEndpoints.RES.STATE,
          Actions.BASE_ACTIONS.READ + `/by_country/${countryId}?readAll=true`).subscribe(
          response => {
            if (response.success) {
              this.states[countryId] = response.data.items;
              obs.next(this.states[countryId]);
            } else {
              obs.next([]);
              this.responseSnackBar.onResponse(response);
            }
          }
        );
      }
    });
  }

  getCounties(stateId: number): Observable<State[]> {
    return new Observable<Country[]>(obs => {
        this.restService.request<PageableResponse<State>>(RequestMethod.GET, ApiEndpoints.RES.STATE,
          Actions.BASE_ACTIONS.READ + `/counties/${stateId}?readAll=true`).subscribe(response => {
          if (response.success) {
            this.counties = response.data.items;
            obs.next(this.counties);
          } else {
            obs.next([]);
            this.responseSnackBar.onResponse(response);
          }
        });
    });
  }
}
